import React from "react";
import Icon from "../../../assets/Icon";
import { useNavigate } from "react-router-dom";

function PreparationCard({ moduleInfo }) {
  const navigate = useNavigate();
  const handleNavigate = () => {
    if (moduleInfo?.hasPreparationGuideAccess) {
      navigate("/preparation");
    } else {
      window.location.href = "https://www.hireplusplus.com/contact-us";
    }
  };
  return (
    <div
      onClick={handleNavigate}
      className="relative driver-dashboard-preparation-guide orange-card flex flex-col justify-center gap-[0.3rem] rounded-xl shadow px-[1rem] xl:px-[1.45rem] py-[1.2rem] basis-[49%] hover-effect cursor-pointer"
    >
      <div className="flex flex-col gap-1">
        <div className="border-[2px] py-[.45rem] px-[.5rem] border-[#DFDFDF] flex justify-center items-center w-fit rounded-[8px]">
          <Icon type="preparation-logo" color="#101828" />
        </div>

        <div className="text-[#101828] font-semibold text-[1rem]">
          Preparation
        </div>
      </div>
      <div className="text-[#475467] font-medium text-[0.875rem]">
        Practice with MCQs, technical tasks, and behavioral questions -
        everything you need for real interview scenarios.
      </div>
      <div className="lg:mt-8">

      <div className="lg:absolute block bottom-5 xl:left-6 left-4">
        {moduleInfo?.hasPreparationGuideAccess ? (
          <div className="w-fit text-amber-600 font-semibold hover:text-amber-500 transition-all duration-200 text-[0.875rem] pt-[0.36rem] flex gap-2 items-center">
            Start Practicing Now <Icon type="right-arrow" color="#d97706" />
          </div>
        ) : (
          <div className="w-fit text-amber-600 font-semibold hover:text-amber-500 transition-all duration-200 text-[0.875rem] pt-[0.36rem] flex gap-2 items-center">
            Request Access <Icon type="right-arrow" color="#d97706" />
          </div>
        )}
      </div>
      </div>
    </div>
  );
}

export default PreparationCard;
